import { Directive, Injector, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Directive()
export class BaseAbstractDirective implements OnDestroy {
  protected subs: { [key: string]: Subscription } = {};
  protected timeouts: { [key: string]: any } = {};

  constructor(public injector: Injector) {}

  ngOnDestroy() {
    Object.keys(this.subs).forEach((key) => {
      const subscription = this.subs[key];
      if (subscription && subscription.unsubscribe) {
        subscription.unsubscribe();
      }
    });
    Object.keys(this.timeouts).forEach((key) => {
      const timeout = this.timeouts[key];
      if (timeout) {
        clearTimeout(timeout);
      }
    });
  }
}
